import React from 'react';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from 'recharts';

const data = [
  { subject: 'Win Rate', A: 85, fullMark: 100 },
  { subject: 'Compliance', A: 92, fullMark: 100 },
  { subject: 'Pricing', A: 78, fullMark: 100 },
  { subject: 'Technical', A: 88, fullMark: 100 },
  { subject: 'Past Performance', A: 95, fullMark: 100 },
  { subject: 'Team Capability', A: 90, fullMark: 100 },
];

export function PerformanceRadar() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Performance Metrics</h3>
      <div className="mt-2">
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
              <PolarGrid />
              <PolarAngleAxis dataKey="subject" />
              <PolarRadiusAxis angle={30} domain={[0, 100]} />
              <Radar
                name="Performance"
                dataKey="A"
                stroke="#8884d8"
                fill="#8884d8"
                fillOpacity={0.6}
              />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}